import React from 'react';
import { Card } from 'antd';
import { RegistrationTypes } from '../AnonymousHeader/RegistrationModal/RegistrationEnums';
import WrappedRegistrationForm from '../AnonymousHeader/RegistrationModal/RegistrationForm/RegistrationForm';
import './passwordReset.less';
import RegistrationDataStore from '../../Registration/containers/RegistrationDataStore';

type PasswordResetProps = {
	userToken: string;
};

export default function PasswordReset({ userToken }: PasswordResetProps) {
	const [isLoading, setIsLoading] = React.useState(false);
	return (
		<Card className="password-reset-container">
			<RegistrationDataStore>
				<WrappedRegistrationForm
					type={RegistrationTypes.ResetPassword}
					isLoading={isLoading}
					setIsLoading={setIsLoading}
					userToken={userToken}
				/>
			</RegistrationDataStore>
		</Card>
	);
}
